import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import prologo from '../images/WinPEProclubLogo1.png';
import "./PageLayout.css";
import "../css/reset.css";
import "../css/loader.css";
import "../css/main.css";
import "../css/menunew.css";
import "animate.css/animate.min.css";
import { Provider } from "react-redux";
import "../components/slick.css";
import "../components/slick-theme.css";
import MediaQuery from "react-responsive";
import KnowledgeCenter from "../components/knowledgeCenter";

// import Header from "../components/TopNavigationBar"
import SidebarMobile from "../components/SidebarMobile";
const BeLogo = "https://bawamasalacompany.com/assets/images/BE(LOGO)footer200x200.png";

// import $ from "jquery"
import createStore from "../state/createStore";
const store = createStore();

export class PageLayout extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeNav: "",
      // prevScrollpos: window.pageYOffset,
      routeUrl: "/",
      isNavChange: true,
      visible: true,
      isModalOpen: false,
      activeNav: this.props.route,
      isShowSidebar: false,
    };
  }
  toggleSidebar = () => {
    this.setState({
      isShowSidebar: !this.state.isShowSidebar,
    });
  };
  handleScroll = (event) => {
    // // console.log("Scroolsadsadsd", event)
    if (typeof window !== "undefined") {
      const prevScrollpos: window.pageYOffset = this.state;
      let currentScrollPos = window.scrollY;
      // let itemTranslate = Math.min(0, currentScrollPos / 3)
      const visible =
        currentScrollPos === 0 && currentScrollPos - 1 < prevScrollpos;
      this.setState({
        prevScrollpos: currentScrollPos,
        visible,
      });
    }
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }
  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll, true);
    this.setState({
      // isNavChange: false,
      routeUrl: window.location.pathname,
    });
    // setTimeout(() => {
    // 	this.setState({
    // 	})
    // }, 1000)
    // console.log(window.location)
  };
  handleActiveNav = (identifier) => {
    const { getActiveRoute } = this.props;
    // getActiveRoute(identifier)
    // this.setState({
    // })
    this.setState({
      // isNavChange: false,
      routeUrl: "/",
    });
    // setTimeout(() => {
    // 	this.setState({
    // 		isNavChange: true,
    // 	})
    // }, 0)
  };

  render() {
    const { children, location } = this.props;
    const {
      isShowSidebar,
      isLoading,
      emailError,
      isSubmitted,
      show,
      isSubmittingEmail,
      visible,
    } = this.state;
    let route = location.pathname.split("/")[1];
    const appChildren =
      process.env.NODE_ENV === "production"
        ? children({ location })
        : children();
    let activeRoute = location.hash;
    return (
      <Provider store={store}>
        <div className="page-layout__viewport">
        <div className="page-layout__viewport__header">
            <div className="menu__bar">
              <MediaQuery query="(min-width: 1230px)">
                <div className="new_header_section">
                  <div className="left_header_section">
                    <div className="h_logo">
                      <Link to="/home/" className="">
                        <img
                          src="https://www.winpeforum.com/assets/elements/WinPEProclubLogo1.png"
                          alt="winpe proclub logo"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="right_header_section" >
                    
                   
                    <span className="dropdown blog" >
                      <Link to="/home#about">About</Link>
                    </span>
                    <span className="dropdown blog" >
                      <Link to="/home#advisors">Advisory Board</Link>
                    </span>
                    <span className="dropdown blog" >
                      <Link to="#">Mentors</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          <div className="col-md-12">
                            <Link to="/cohortI-mentors">
                              <div className="t_n">Cohort I</div>
                            </Link>
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortII-mentors">
                              <div className="t_n">Cohort II</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortIII-mentors">
                              <div className="t_n">Cohort III</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortIV-mentors">
                              <div className="t_n">Cohort IV</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortV-mentors">
                              <div className="t_n">Cohort V</div>
                            </Link>{" "}
                          </div>
                           <div className="col-md-12">
                            <Link className="" to="/cohortVI-mentors">
                              <div className="t_n">Cohort VI</div>
                            </Link>{" "}
                          </div>
                        </div>
                      </div>
                    </span>
                     
                    <span className="dropdown blog" >
                      <Link to="#">Mentees</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          <div className="col-md-12">
                            <Link to="/winpementees">
                              <div className="t_n">Cohort I</div>
                            </Link>
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortII">
                              <div className="t_n">Cohort II</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortIII">
                              <div className="t_n">Cohort III</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortIV">
                              <div className="t_n">Cohort IV</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortV">
                              <div className="t_n">Cohort V</div>
                            </Link>{" "}
                          </div>
                           <div className="col-md-12">
                            <Link className="" to="/cohortVI">
                              <div className="t_n">Cohort VI</div>
                            </Link>{" "}
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/cohortVII">
                              <div className="t_n">Cohort VII</div>
                            </Link>{" "}
                          </div>
                        </div>
                      </div>
                    </span>
                    
                    <span className="dropdown blog" style={{fontFamily:'Archivo Narrow'}}>
                      <Link to="#">Events</Link>
                      <div className="dropdown-content">
                        <div className="row">
                          <div className="col-md-12">
                            <Link to="/events">
                              <div className="t_n">Events</div>
                            </Link>
                          </div>
                          <div className="col-md-12">
                            <Link className="" to="/testimonials">
                              <div className="t_n">Testimonials</div>
                            </Link>{" "}
                          </div>
                           
                        </div>
                      </div>
                    </span>
                    <span className="blog" style={{fontFamily:'Archivo Narrow'}}>
                      <Link target="_BLANK" to="/connect">Connect with winpe</Link>
                    </span>
                  </div>
                  <div className="new_desTop_sm">
                    <div className="social_icons_top">
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.facebook.com/winpeforum/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-facebook"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://twitter.com/winpeforum"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-twitter"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.linkedin.com/company/winpeforum"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-linkedin"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/WinPEforum/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-instagram"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://www.youtube.com/watch?v=q-bE10X9KcA&t=2s"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-youtube"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://winpeinsights.medium.com/"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-medium" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div className="iconn">
                        <a
                          rel="noopener noreferrer"
                          href="https://chat.whatsapp.com/JeAI8cBNsvSBtwY5jzNk6Y"
                          target="_blank"
                          className=""
                        >
                          <i className="fa fa-whatsapp"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </MediaQuery>
              <MediaQuery query="(max-width: 1230px)">
                <span>
                  <span className="logo">
                    <Link to="/">
                      <img
                        src="https://www.winpeforum.com/assets/elements/WinPEProclubLogo1.png"
                        alt="WinPe Logo"
                        className="mobile__logo"
                      />
                    </Link>
                  </span>
                  <span className="hmb pull-right" onClick={this.toggleSidebar}>
                    <i className="fa fa-bars" />
                  </span>
                  <SidebarMobile
                    show={isShowSidebar}
                    onHide={this.toggleSidebar}
                    activePathname={activeRoute}
                  />
                </span>
              </MediaQuery>
            </div>
          </div>
         
          {appChildren}
          <div className="last_section">
            <KnowledgeCenter />
          </div>
          <div className="page-layout__viewport__footer_content">
           
              <MediaQuery query="(min-width:1001px)">
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div className="left__content"   >
                      © Winpe ProClub<sup>&trade;</sup> 2020. All Rights
                      Reserved. <a href="https://winpeforum.com/PrivacyPolicy/" style={{textDecoration:'underline'}} target="_blank">Privacy Policy</a>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="middle__content"></div>
                  </div>
                  <div className="col-md-4 col-sm-4">
                    <div className="right__content"  >
                      Powered By{" "}
                      <a
                        href="https://websitesketchers.com"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="" style={{color: "#fff"}}
                      >
                       Website Sketchers
                      </a>
                    </div>
                  </div>
                </div>
              </MediaQuery>
             
            <div>
              <MediaQuery query="(max-width:1000px)">
                <div className="row">
                  <div className="col-sm-12 col-xs-12">
                    <div className="left__content">
                      © Winpe ProClub<sup>&trade;</sup> 2021. All Rights
                      Reserved.
                    </div>
                  </div>
                  <div className="col-sm-12 col-xs-12">
                    <div className="middle__content"></div>
                  </div>
                  <div className="col-sm-12 col-xs-12">
                    <div className="right__content">
                      Powered By{" "}
                      <a
                        href="https://websitesketchers.com"
                        rel="noopener noreferrer"
                        target="_blank"
                        className="" style={{color: "#fff"}}
                      >
                       Website Sketchers
                      </a>
                    </div>
                  </div>
                </div>
              </MediaQuery>
            </div>
          </div>
        </div>
      </Provider>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx